export { default as FolderImageSolidIcon } from './FolderImageSolidIcon';
